export default {"src":"/_next/static/media/NRICHED_Logo_yellow.c8bae45e.svg","height":49,"width":289,"blurWidth":0,"blurHeight":0};